import {
    ILoadableArray,
    Loadable,
    createDefaultILoadableArray,
    createDefaultLoadable,
} from '../../models/loadable';
import { IRuleSchedule } from '../../models/rule-schedule.interface';

export interface RuleScheduleState {
    /** All reusable, org-level rule schedules (management screen + link options). */
    schedules: ILoadableArray<IRuleSchedule>;
    /** Schedules linked to a single rule (loaded for the rule editor). */
    ruleLinks: ILoadableArray<IRuleSchedule> & { ruleId: string | null };
    /** Shared across create/update/delete operations. */
    saving: Loadable;
    /** Shared across link/unlink operations. */
    linking: Loadable;
}

export const initialRuleScheduleState: RuleScheduleState = {
    schedules: createDefaultILoadableArray<IRuleSchedule>(),
    ruleLinks: { ...createDefaultILoadableArray<IRuleSchedule>(), ruleId: null },
    saving: createDefaultLoadable(),
    linking: createDefaultLoadable(),
};
